const DefaultPalette = (mode, skin) => {
  // ** Vars
  const whiteColor = '#FFF';
  const lightColor = 'rgb(47, 43, 61)'; // ✅ Added rgb()
  const darkColor = 'rgb(208, 212, 241)'; // ✅ Added rgb()
  const darkPaperBgColor = '#1B2431'
  const mainColor = mode === 'light' ? lightColor : darkColor

  // Helper function to convert rgb to rgba with alpha
  const withAlpha = (color, alpha) => {
    return color.replace('rgb', 'rgba').replace(')', `, ${alpha})`);
  };

  const defaultBgColor = () => {
    if (skin === 'bordered' && mode === 'light') {
      return whiteColor
    } else if (skin === 'bordered' && mode === 'dark') {
      return darkPaperBgColor
    } else if (mode === 'light') {
      return '#F8F7FA'
    } else return '#25293C'
  }

  return {
    customColors: {
      dark: darkColor,
      main: mainColor,
      light: lightColor,
      lightPaperBg: whiteColor,
      darkPaperBg: darkPaperBgColor,
      bodyBg: mode === 'light' ? '#F8F7FA' : '#25293C',
      trackBg: mode === 'light' ? '#F1F0F2' : '#363B54',
      avatarBg: mode === 'light' ? '#DBDADE' : '#4A5072',
      tableHeaderBg: mode === 'light' ? '#F6F6F7' : '#4A5072'
    },
    mode: mode,
    common: {
      black: '#000',
      white: whiteColor
    },
    primary: {
      light: '#313D4F',
      main: '#313D4F',
      dark: '#273142',
      contrastText: whiteColor
    },
    main: {
      light: '#23A26D',
      main: '#23A26D',
      dark: '#1F8C61',
      contrastText: whiteColor
    },
    secondary: {
      light: '#B2B4B8',
      main: '#8E939D',
      dark: '#949699',
      contrastText: whiteColor
    },
    error: {
      light: '#ED6F70',
      main: '#EA5455',
      dark: '#CE4A4B',
      contrastText: whiteColor
    },
    warning: {
      light: '#FFAB5A',
      main: '#FF9F43',
      dark: '#E08C3B',
      contrastText: whiteColor
    },
    info: {
      light: '#98D1FF',
      main: '#4c86bc',
      dark: '#336da3',
      contrastText: whiteColor
    },
    success: {
      light: '#42CE80',
      main: '#28C76F',
      dark: '#23AF62',
      contrastText: whiteColor
    },
    teal: {
      light: '#26C6DA',
      main: '#00ACC1',
      dark: '#0097A7',
      contrastText: whiteColor
    },
    violet: {
      light: '#9575CD',
      main: '#7E57C2',
      dark: '#673AB7',
      contrastText: whiteColor
    },
    yellow: {
      light: '#FFD54F',
      main: '#FFC107',
      dark: '#FFA000',
      contrastText: whiteColor
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#F5F5F5',
      A200: '#EEEEEE',
      A400: '#BDBDBD',
      A700: '#616161'
    },

    text: {
      primary: withAlpha(mainColor, 0.78), // ✅ Now properly formatted
      secondary: withAlpha(mainColor, 0.68),
      disabled: withAlpha(mainColor, 0.42)
    },
    divider: withAlpha(mainColor, 0.16),
    action: {
      active: withAlpha(mainColor, 0.54),
      hover: withAlpha(mainColor, 0.04),
      selected: withAlpha(mainColor, 0.06),
      selectedOpacity: 0.06,
      disabled: withAlpha(mainColor, 0.26),
      disabledBackground: withAlpha(mainColor, 0.12),
      focus: withAlpha(mainColor, 0.12)
    },  
    background: {
      paper: mode === 'light' ? whiteColor : darkPaperBgColor,
      default: defaultBgColor()
    },
    btn: {
      primary: '#23A26D'
    }
  }
}

export default DefaultPalette
